import React, { Component } from 'react'
import style from './style.module.less'
import { Button } from 'hljd'

const defaultImg =
  'https://qnm.hunliji.com/FgwaJfcqaRk0FcT8OyRX2J84l_ny?imageView2/1/w/220/h/166'

export default class Index extends Component {
  render() {
    const { previewScene, previewCover, changeScene, store } = this.props
    let tabList = [
      {
        name: '视频',
        type: 'video'
      },
      {
        name: '图片',
        type: 'photo'
      }
    ]
    tabList.forEach(item => {
      item.selected = item.type === previewScene
      item.disabled = !!store[item.type].cover_path
    })
    return (
      <div className={style.previewContainer}>
        <div className={style.previewHeader}>
          <div className={style.previewTitle}>封面预览</div>
          {previewCover && previewCover.cover_path ? (
            <div className={style.preview}>
              {previewScene === 'video' && (
                <ImgCard
                  src={previewCover.cover_path}
                  isVideo={true}
                  className={style.img}
                />
              )}
              {previewScene === 'photo' &&
                !!previewCover && (
                  <ImgCard
                    src={previewCover.cover_path}
                    className={style.img}
                  />
                )}
              {previewScene === 'vr' && (
                <ImgCard
                  src={previewCover.cover_path}
                  isVideo={false}
                  className={style.img}
                />
              )}
              <div className={style.tabChange}>
                {tabList.map((tab, index) => {
                  return (
                    <p
                      key={index}
                      className={tab.selected ? style.selected : {}}
                    >
                      {tab.name}
                    </p>
                  )
                })}
              </div>
            </div>
          ) : (
            <div className={style.default}>
              <img src={defaultImg} alt="" />
            </div>
          )}
        </div>
        <div className={style.previewTabs}>
          <div className={style.previewTitle}>
            切换预览<br />不同封面
          </div>
          <div className={style.previewTab}>
            {tabList.map((tab, index) => {
              return (
                <Button
                  // disabled={!tab.disabled}
                  type={tab.selected ? 'primary' : 'default'}
                  onClick={() => changeScene(tab.type)}
                >
                  {tab.name}
                </Button>
              )
            })}
          </div>
        </div>
      </div>
    )
  }
}

const ImgCard = ({ src, className, isVideo, outStyle, imgStyle }) => {
  // 返回居中裁剪的缩略图
  const getCenterUrl = originUrl => {
    let concat = '|'

    if (!originUrl) {
      return
    }

    if (originUrl.indexOf('?') === -1) {
      concat = '?'
    }

    return originUrl + concat + 'imageView2/1/w/220/h/166'
  }
  return (
    <div className={className} style={outStyle}>
      <img src={getCenterUrl(src)} style={imgStyle} />
      <img className={style.imgCard} src={defaultImg} alt="" />
      {isVideo && <i className={`iconfont icon-bofang ${style.play}`} />}
    </div>
  )
}
